import type { IconNode } from '../types';

/**
 * @name hedgehog
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxMSAzIDcuNyA1LjcgN2wuMS0yLjggMi43LjYgMS4zLTIuNkwxMiA0bDIuMi0xLjggMS4zIDIuNiAyLjctLjYuMSAyLjggMi43LjctMS4yIDIuNUwyMiAxMmwtMi4yIDEuOCAxLjIgMi41LTMgLjciIC8+CiAgPHBhdGggZD0iTTEwIDE3aC4wMSIgLz4KICA8cGF0aCBkPSJNMyAxNmMyLjggMCA1LTIuMiA1LTUgMy4zIDAgNiAyLjcgNiA2YTQgNCAwIDAgMCA0IDRoLThjLTEuMSAwLTIuNi0uNi0zLjQtMS40TDMgMTZ2LTEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/hedgehog
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hedgehog: IconNode = [
  [
    'path',
    {
      d: 'M4 11 3 7.7 5.7 7l.1-2.8 2.7.6 1.3-2.6L12 4l2.2-1.8 1.3 2.6 2.7-.6.1 2.8 2.7.7-1.2 2.5L22 12l-2.2 1.8 1.2 2.5-3 .7',
      key: 'su90o8',
    },
  ],
  ['path', { d: 'M10 17h.01', key: 'nbq80n' }],
  [
    'path',
    {
      d: 'M3 16c2.8 0 5-2.2 5-5 3.3 0 6 2.7 6 6a4 4 0 0 0 4 4h-8c-1.1 0-2.6-.6-3.4-1.4L3 16v-1',
      key: 'wsk636',
    },
  ],
];

export default hedgehog;
